/**
 * Farbenbote Color Picker SKU Integration for Dawn Theme
 * Vanilla JS rewrite - replaces jQuery-dependent Empire version
 *
 * Handles:
 * - Color selection → variant matching
 * - Cart properties (Farbe, RGB, Bez)
 * - URL updates with ?color= parameter
 * - SKU modification with HBW value
 */

var g_data;

function colorPane(bgColor, toenId, rgb, boxColor, displayName) {
  var farbegr = document.getElementById('farbegr');
  var toenid = document.getElementById('toenid');
  var rgbInput = document.getElementById('rgb');
  var hint = document.getElementById('farbegrhinweis');
  var rahmen = document.getElementById('farbegrrahmen');
  var kasten = document.getElementById('waehlenkasten');
  var weiss = document.getElementById('waehlenweiss');
  var bunt = document.getElementById('waehlenbunt');
  var toenidx = document.getElementById('toenidx');

  if (farbegr) farbegr.style.backgroundColor = bgColor;
  if (toenid) toenid.value = toenId;
  if (rgbInput) rgbInput.value = rgb;
  if (hint) hint.style.display = 'none';
  if (rahmen) rahmen.style.display = 'block';
  if (kasten) {
    kasten.style.backgroundColor = boxColor;
    kasten.style.display = 'block';
  }
  if (weiss) weiss.style.display = 'none';
  if (bunt) bunt.style.display = 'block';
  if (toenidx) toenidx.innerHTML = displayName;

  location.href = '#waehlenkasten';

  if (window.matchMedia('(max-width: 900px)').matches) {
    var mitte = document.getElementById('farbemitte');
    var searchCol = document.getElementById('searchColorCol');
    if (mitte) mitte.style.display = 'none';
    if (searchCol) searchCol.style.display = 'none';
  }
}

function picker__get() {
  hide();
  xhide('farbemitte');

  var closeBtn = document.querySelector('.color-picker__close');
  if (closeBtn) closeBtn.style.display = 'none';

  var groupCol = document.querySelector('.color__group__column');
  if (groupCol) groupCol.classList.remove('picker__mobile');

  var categories = document.querySelectorAll('.farbkategorie');
  categories.forEach(function(cat) {
    cat.classList.remove('active');
  });

  var devBack = document.getElementById('dev_back');
  var interneFarben = document.getElementById('InterneFarben');
  var toenid = document.getElementById('toenid');
  var customsColor = document.getElementById('customs-color');
  var toenidx = document.getElementById('toenidx');
  var farbegr = document.getElementById('farbegr');
  var previewModal = document.getElementById('previewModal');

  var isWhite = farbegr && farbegr.style.backgroundColor === 'rgb(255, 255, 255)';

  if (devBack) {
    devBack.style.color = '#000';
    devBack.style.border = '1px solid #000';
    devBack.style.maxWidth = '270px';

    if (isWhite) {
      devBack.style.backgroundColor = '#fff';
      devBack.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0627/8817/4056/files/mes-logo.png?v=1645767450" width="24" height="24"><div><strong>Wunschfarbton</strong></div>';
    } else {
      devBack.style.backgroundColor = '#fad115';
      devBack.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0627/8817/4056/files/mes-logo.png?v=1645767450" width="24" height="24"><strong style="margin-left:5px;">Wunschfarbton</strong> w\u00e4hlen';
    }
  }

  if (interneFarben) {
    interneFarben.style.display = 'inline-block';
    interneFarben.style.backgroundImage = 'none';
    if (farbegr) {
      interneFarben.style.backgroundColor = farbegr.style.backgroundColor;
      interneFarben.value = interneFarben.style.backgroundColor;
    }
  }
  if (previewModal) previewModal.style.display = 'none';
  if (toenid) toenid.value = toenid.value;
  if (customsColor && toenidx) customsColor.value = toenidx.innerText;

  /* Fetch color data */
  fetch('https://cdn.shopify.com/s/files/1/0606/1821/1516/files/all-colors.json')
    .then(function(r) { return r.json(); })
    .then(function(d) { g_data = d; })
    .catch(function(e) { console.error(e); });

  /* Dawn variant selection */
  selectDawnVariant();
}

/**
 * Dawn-specific variant selection
 * Maps color Farbtonklasse to Dawn variant options
 */
function selectDawnVariant() {
  if (!g_data || !window.currentProduct) return;

  var customsColor = document.getElementById('customs-color');
  var interneFarben = document.getElementById('InterneFarben');
  var rgbValue = interneFarben ? interneFarben.style.backgroundColor : '';
  var colorName = customsColor ? customsColor.value : '';
  var devBack = document.getElementById('dev_back');
  var hwb = devBack ? devBack.getAttribute('data-hwb') : '';
  var rgbAttr = devBack ? devBack.getAttribute('data-rgb') : '';

  /* Find the matching color in g_data */
  var matchedColor = null;
  var rgbNorm = rgbValue.replace('rgb(', '').replace(')', '').replace(/\s/g, '');

  if (g_data && rgbNorm && rgbNorm !== '255,255,255') {
    for (var i = 0; i < g_data.length; i++) {
      var item = g_data[i];
      var itemRgb = item.Rcolor.trim() + ',' + item.Gcolor.trim() + ',' + item.Bcolor.trim();
      if (rgbNorm === itemRgb) {
        matchedColor = item;
        break;
      }
    }
  }

  var farbtonklasse = matchedColor ? matchedColor.Farbtonklasse : '1';

  /* Find and select the correct variant in Dawn */
  var variantRadios = document.querySelectorAll('variant-radios input[type="radio"]');
  var variantSelects = document.querySelectorAll('variant-selects select');

  /* Try radio buttons first */
  variantRadios.forEach(function(radio) {
    var val = radio.value;
    var fieldset = radio.closest('fieldset');
    var legend = fieldset ? fieldset.querySelector('legend, .form__label') : null;
    var isColorOption = legend && legend.textContent.toLowerCase().indexOf('farbe') > -1;

    if (isColorOption) {
      /* Match based on Farbtonklasse or option value containing PC number */
      var pcMatch = 'PC' + farbtonklasse;
      var valLower = val.toLowerCase();

      if (rgbNorm === '255,255,255' && valLower.indexOf('wei') > -1) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (val.indexOf(pcMatch) > -1 || val.indexOf('get\u00f6nt') > -1 && val.indexOf(farbtonklasse) > -1) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });

  /* Try select dropdowns */
  variantSelects.forEach(function(select) {
    var label = select.closest('.product-form__input');
    var labelText = label ? label.querySelector('label') : null;
    var isColorOption = labelText && labelText.textContent.toLowerCase().indexOf('farbe') > -1;

    if (isColorOption) {
      var options = select.querySelectorAll('option');
      options.forEach(function(opt) {
        var val = opt.value;
        var pcMatch = 'PC' + farbtonklasse;

        if (rgbNorm === '255,255,255' && val.toLowerCase().indexOf('wei') > -1) {
          select.value = val;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (val.indexOf(pcMatch) > -1) {
          select.value = val;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  });

  /* Update URL with color parameter */
  if (colorName) {
    var url = window.location.href;
    var params = new URLSearchParams(window.location.search);
    params.set('color', colorName);
    window.history.pushState({ path: url }, '', url.split('?')[0] + '?' + params.toString());
  }

  /* Update cart properties */
  updateCartProperties(colorName, rgbNorm, matchedColor ? matchedColor.Farbtonhilfsbezeichnung : '');
}

/**
 * Update hidden form inputs for cart line item properties
 */
function updateCartProperties(farbe, rgb, bezeichnung) {
  var form = document.querySelector('form[data-type="add-to-cart-form"]');
  if (!form) return;

  setOrCreateInput(form, 'properties[Farbe]', farbe);
  setOrCreateInput(form, 'properties[RGB]', rgb);
  setOrCreateInput(form, 'properties[Bez]', bezeichnung);
}

function setOrCreateInput(form, name, value) {
  var input = form.querySelector('input[name="' + name + '"]');
  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    form.appendChild(input);
  }
  input.value = value || '';
}

/* Load color from URL on page load */
document.addEventListener('DOMContentLoaded', function() {
  var params = new URLSearchParams(window.location.search);
  var colorParam = params.get('color');

  if (colorParam && window.currentProduct) {
    var customsColor = document.getElementById('customs-color');
    if (customsColor) customsColor.value = colorParam;

    /* Defer to let colorPicker.js initialize first */
    setTimeout(function() {
      fetch('https://cdn.shopify.com/s/files/1/0606/1821/1516/files/all-colors.json')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          g_data = data;
          var match = data.find(function(item) {
            return item.Farbton_ID.trim() === colorParam;
          });

          if (match) {
            var rgb = 'rgb(' + match.Rcolor + ', ' + match.Gcolor + ', ' + match.Bcolor + ')';
            var interneFarben = document.getElementById('InterneFarben');
            if (interneFarben) {
              interneFarben.style.backgroundColor = rgb;
              interneFarben.value = rgb;
            }

            var devBack = document.getElementById('dev_back');
            if (devBack) {
              devBack.setAttribute('data-hwb', match.Y || '');
              devBack.setAttribute('data-rgb', match.Rcolor.trim() + ',' + match.Gcolor.trim() + ',' + match.Bcolor.trim());
              devBack.style.backgroundColor = '#fad115';
              devBack.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0627/8817/4056/files/mes-logo.png?v=1645767450" width="24" height="24"><strong style="margin-left:5px;">Wunschfarbton</strong> w\u00e4hlen';
            }

            selectDawnVariant();
          }
        })
        .catch(function(e) { console.error(e); });
    }, 600);
  }
});
